import { apis } from '../apiBase/apiBase';
export const eventApis = apis.injectEndpoints({
    endpoints: (builder) => ({
        getEvents: builder.query({
            query: (params) => {
                return {
                    url: `events`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        downloadMeetingMinutesDocument: builder.query({
            query: (params) => {
                return {
                    url: `events/${params.eventId}/meeting-minutes/download`,
                    method: 'GET',
                };
            },
        }),
        createMeetingMinutesAutomatic: builder.mutation({
            query: (params) => {
                return {
                    url: 'events/meeting-minutes/create-automatic',
                    method: 'POST',
                    body: params,
                };
            },
        }),
        insertEventRecordingAndUploadRecordingFile: builder.mutation({
            query: (params) => {
                return {
                    url: 'event-recordings/insert-and-upload',
                    method: 'POST',
                    body: params,
                };
            },
        }),
        getEventRecordingsCount: builder.query({
            query: (params) => {
                return {
                    url: 'event-recordings/count',
                    method: 'GET',
                    params: params,
                };
            },
        }),
    }),
    overrideExisting: false,
});
export const { useGetEventsQuery, useLazyGetEventsQuery, useLazyDownloadMeetingMinutesDocumentQuery, useCreateMeetingMinutesAutomaticMutation, useInsertEventRecordingAndUploadRecordingFileMutation, useGetEventRecordingsCountQuery, useLazyGetEventRecordingsCountQuery, } = eventApis;
